import React, { useEffect, useState } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "./firebase";
import "./styles.css";

function InternList() {
  const [entries, setEntries] = useState([]);
  const [search, setSearch] = useState("");
  const [filterLabel, setFilterLabel] = useState("");
  const [expanded, setExpanded] = useState({});
  const [sortBy, setSortBy] = useState("name");

  useEffect(() => {
    const fetchData = async () => {
      const snapshot = await getDocs(collection(db, "internships"));
      const data = snapshot.docs
        .map((doc) => ({ id: doc.id, ...doc.data() }))
        .filter((entry) => entry.approved);
      setEntries(data);
    };
    fetchData();
  }, []);

  const toggleExpand = (id) => {
    setExpanded((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const filtered = entries
    .filter((entry) => {
      const matchSearch =
        !search ||
        entry.name.toLowerCase().includes(search.toLowerCase()) ||
	entry.major.toLowerCase().includes(search.toLowerCase()) ||
        entry.company.toLowerCase().includes(search.toLowerCase()) ||
        entry.role.toLowerCase().includes(search.toLowerCase());
      const matchLabel =
        !filterLabel || (entry.labels && entry.labels.includes(filterLabel));
      return matchSearch && matchLabel;
    })
    .sort((a, b) => {
      const fieldA = (a[sortBy] || "").toLowerCase();
      const fieldB = (b[sortBy] || "").toLowerCase();
      return fieldA.localeCompare(fieldB);
    });

  const uniqueLabels = [...new Set(entries.flatMap((e) => e.labels || []))].sort((a, b) =>
    a.localeCompare(b)
  );

  return (
    <div className="intern-list-container">
      <h2>Past SWE Internships</h2>

      <p style={{ fontSize: "0.9rem", color: "#555", marginBottom: "1rem" }}>
        If at any point you would like your information removed, please email 
        <a href="mailto:membership@swetamu.org" style={{ color: "#4497CB" }}> membership@swetamu.org</a>.
      </p>

      <div className="filter-row">
        <input
          type="text"
          placeholder="Search by name, major, role, or company"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <select value={filterLabel} onChange={(e) => setFilterLabel(e.target.value)}>
          <option value="">Filter by Label (optional)</option>
          {uniqueLabels.map((label) => (
            <option key={label} value={label}>
              {label}
            </option>
          ))}
        </select>
        <select value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
          <option value="name">Sort by Name (A-Z)</option>
          <option value="major">Sort by Major (A-Z)</option>
          <option value="company">Sort by Company (A-Z)</option>
        </select>
      </div>

      <div className="table-header">
        <span>Name</span>
        <span>Major</span>
        <span>Role</span>
        <span>Company</span>
        <span>Labels</span>
        <span>More Info</span>
      </div>

      {filtered.length === 0 ? (
        <p style={{ marginTop: "1rem" }}>No entries match your filters.</p>
      ) : (
        filtered.map((entry) => (
          <div className="table-row" key={entry.id}>
            <span>{entry.name}</span>
            <span>{entry.major}</span>
            <span>{entry.role}</span>
            <span>{entry.company}</span>
            <span>
              {entry.labels?.map((label, i) => (
                <span key={i} className="tag">
                  {label}
                </span>
              ))}
            </span>
            <span>
              <button
                className="more-info-button"
                onClick={() => toggleExpand(entry.id)}
              >
                {expanded[entry.id] ? "Hide" : "Show"}
              </button>
            </span>

            {expanded[entry.id] && (
              <div className="more-info">
                <p><strong>Location:</strong> {entry.location}</p>
                <p><strong>Session:</strong> {entry.session}</p>
                {entry.applicationDate && <p><strong>Applied:</strong> {entry.applicationDate}</p>}
                {entry.offerDate && <p><strong>Offer Received:</strong> {entry.offerDate}</p>}
                <p>
                  <strong>Contact:</strong>{" "}
                  {entry.shareContact
                    ? entry.contact
                    : "This person did not opt in to be contacted."}
                </p>
                {entry.description && <p><strong>Description:</strong> {entry.description}</p>}
                {entry.source && <p><strong>How they got it:</strong> {entry.source}</p>}
              </div>
            )}
          </div>
        ))
      )}
    </div>
  );
}

export default InternList;

